/**
 * @function v3sTestResultList
 * @memberOf v3sWbtPlayerApp:page:elements
 * @description
 * 
 * # Area
 * Eine Fläche kann definiert werden. Diese kann verschiedene Typen haben. Auf der Area können Ereignisse gebunden werden.
 */

angular.module('v3sWbtPlayerApp').directive('v3sTestResultList', function () {
    return {
        restrict: 'EA',
        transclude: true,
        require: '^v3sDocument',
        templateUrl: "app/js/page/elements/v3sTestResultList.tpl.html",
        link: function (scope, element, attrs, docCtrl) {
            if (!!scope.id) {
                docCtrl.addElement(element);
            }
        }

    }
});
